/* eslint-disable complexity */
import React from "react";

import { useCountriesOrRegionsList } from "../../../../helpers/countriesOrRegionsList";
import { DropdownOption } from "../../../../helpers/optionSets";
import { CommonIntroShippingDataType } from "../../../../models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyShippingProps = {
  dataInForm: CommonIntroShippingDataType;
};

const ShippingConfig: Map<string, ReadOnlyFormItem> = new Map([
  [
    "shippingCountryOrRegion",
    {
      title: "countryOrRegion",
      mapper: (
        data: CommonIntroShippingDataType,
        _localizedStrings: Map<string, string>,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        additionalData?: Map<string, any>
      ) => {
        if (!additionalData) {
          return null;
        }
        const countriesOrRegionsList = additionalData.get(
          "countriesOrRegionsList"
        ) as Array<DropdownOption>;
        const selectedCountryCode = data.shippingCountryOrRegion;
        for (const country of countriesOrRegionsList) {
          if (country.value === selectedCountryCode) {
            return country.label;
          }
        }
        return "";
      },
    },
  ],
  [
    "shippingAddress",
    {
      title: "address",
      mapper: (data: CommonIntroShippingDataType) => {
        if (!data.shippingAddressLine1 && !data.shippingAddressLine2) {
          return "";
        }
        if (!data.shippingAddressLine2) {
          return data.shippingAddressLine1;
        }
        return `${data.shippingAddressLine1} </br> ${data.shippingAddressLine2}`;
      },
      isAnswerWithHtmlContent: true,
    },
  ],
  ["shippingCity", { title: "city" }],
  ["shippingStateRegion", { title: "stateRegion" }],
  ["shippingPostalCode", { title: "postalCode" }],
  ["shippingPhone", { title: "phone" }],
]);

export const ReadOnlyShipping = ({ dataInForm }: ReadOnlyShippingProps) => {
  const countriesOrRegionsList = useCountriesOrRegionsList();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const additionalData = new Map<string, any>([["countriesOrRegionsList", countriesOrRegionsList]]);

  return (
    <ReadOnlyForm
      formConfig={ShippingConfig}
      formData={dataInForm}
      additionalData={additionalData}
    />
  );
};
